<template>
  <!-- Site wrapper -->
  <div class="wrapper">
    <cabecalho tituloPagina="Escritórios" />
    <menuLateral />

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <b-button class="botoes" variant="outline-primary btn-sm mt-2" @click="incluirEscritorio()" :disabled="flagsDeControle.carregandoDados.status">Incluir</b-button>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>
      <!-- Main content -->
      <section class="content">
        <!-- Default box -->
        <div class="card">
        <div class="card-body">
          <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
            <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
          <div class="card bg-light d-flex flex-fill">
            <div class="card-header border-bottom-0">
              <form v-on:keyup.enter="buscarRegistros()">
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <b-form-group label="Nome" label-for="nomeFiltro" label-align-sm="left" label-size="sm" class="mb-0"></b-form-group>
                    <b-form-input id="nome" v-model="camposFiltroPesquisa.nome" type="text" :disabled="flagsDeControle.carregandoDados.status"></b-form-input>
                  </div>
                  <div class="form-group col-md-4">
                    <b-form-group label="Código da Empresa" label-for="codigoEmpresaFiltro" label-align-sm="left" label-size="sm" class="mb-0"></b-form-group>
                    <b-form-input id="codigo_empresa" v-model="camposFiltroPesquisa.codigo_empresa" type="text" :disabled="flagsDeControle.carregandoDados.status"></b-form-input>
                  </div>
                  <div class="form-group col-md-4">
                    <b-form-group label="E-mail" label-for="emailFiltro" label-align-sm="left" label-size="sm" class="mb-0"></b-form-group>
                    <b-form-input id="email" v-model="camposFiltroPesquisa.email" type="text" :disabled="flagsDeControle.carregandoDados.status"></b-form-input>
                  </div>
                  <div class="form-group col-md-3">
                    <b-form-group label="CPF/CNPJ" label-for="cpf_cnpjFiltro" label-align-sm="left" label-size="sm" class="mb-0"></b-form-group>
                    <b-form-input id="cpf_cnpj" v-mask="mascaraDocumentoIdentificacao(camposFiltroPesquisa.cpf_cnpj)" maxlength="18" v-model="camposFiltroPesquisa.cpf_cnpj" type="text" :disabled="flagsDeControle.carregandoDados.status" class="campo-DocumentoCpfCnpjAlfanumericoUppercase"></b-form-input>
                  </div>
                  <div class="form-group col-md-2">
                    <b-form-group label="Status" label-for="statusFiltro" label-align-sm="left" label-size="sm" class="mb-0"></b-form-group>
                    <b-form-select id="status" v-model="camposFiltroPesquisa.status" :options="statusFiltroOptions" :disabled="flagsDeControle.carregandoDados.status" size="sm" class="comboFonteDefault"></b-form-select>
                  </div>
                  <div class="form-group col-md-2">
                    <b-form-group label="Produto" label-for="produto" label-align-sm="left" label-size="sm" class="mb-0"></b-form-group>
                    <b-form-select id="produto" v-model="camposFiltroPesquisa.id_contexto" :options="comboContextoProduto" :disabled="flagsDeControle.carregandoDados.status" size="sm" class="comboFonteDefault">
                    </b-form-select>
                  </div>
                  <div class="form-group text-right mt-auto ml-auto">
                    <b-button class="botoes" variant="outline-secondary btn-sm" @click="limparFiltros()" :disabled="flagsDeControle.carregandoDados.status">Limpar</b-button>
                    <b-button class="botoes ml-1" variant="outline-primary btn-sm" @click="buscarRegistros()" :disabled="flagsDeControle.carregandoDados.status">Buscar</b-button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <default-table
            :items="listaEscritorios"
            :fields="fields"
            :sort-by="componenteOrdenacao.campo"
            :sort-direction="componenteOrdenacao.sentido"
            :busy="flagsDeControle.carregandoDados.status"
            @sortChanged="ordenarLista"
            :tbody-tr-class="tabelaSemRegistros">
            <template #empty>
              <em>Nenhum registro encontrado.</em>
            </template>
            <template #cell(nome)="row">
              <a href="#" :class="destacarEscritorioInativo(row.item.ativo)" v-on:click.stop.prevent="editarEscritorio(row.item.id)" :disabled="flagsDeControle.carregandoDados.status">
                <imageStream v-if="escritorioTemLogo(row.item.endereco_logotipo)" class="mr-2" rounded="circle" width="32" height="32" :imageStream="{ codigoBase64: null, urlExterna: row.item.endereco_logotipo }" alt="" />
                <b-img v-else class="mr-2" rounded="circle" width="32" height="32" :src="require('@/assets/img/usuario-sem-foto.png')" alt=""/>
                {{ row.item.nome }}
              </a>
            </template>
            <template #cell(codigo_empresa)="row">
                {{ row.item.codigo_empresa }}
            </template>
            <template #cell(cpf_cnpj)="row">
              <a>
                {{ row.item.cpf_cnpj | VMask(mascaraDocumentoIdentificacao(row.item.cpf_cnpj)) }}
              </a>
            </template>
            <template #cell()="row">
              <span>{{ row.value }}</span>
            </template>
          </default-table>
          <pagination :fonteDeDados="componentePaginacao.fonteDeDados" :disabled="flagsDeControle.carregandoDados.status" @navegarNaPaginacao="obterDadosPaginados"/>
        </div>
      </div>
      </section>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
  </div>
  <!-- ./wrapper -->
</template>

<script>
import Escritorios from './js'
export default Escritorios
</script>

<style scoped>
@import "./scss/escritorio.scss";
</style>
